<template>
  <mm-alert
    class="order-detail-tips"
    key="needAuth"
    type="warning"
    show-icon
    :closable="false"
  >
    <div slot="title">
      <span v-t="signText" />
      <a
        v-if="verifyType === FADADA_VERTIFY"
        href=""
        @click="toSign"
      >，{{ $t("order.sign") }}</a>
    </div>
  </mm-alert>
</template>
<script>
import {
  FADADA_VERTIFY,
} from "@utils/constants";
export default {
  props: {
    signInfo: {
      type: Object,
      default: () => {}
    },
    verifyType: {
      type: Number,
      default: 1
    }
  },
  data(){
    return {
      FADADA_VERTIFY
    }
  },
  computed: {
    signText() {
      if (this.verifyType === FADADA_VERTIFY) {
        return this.signInfo.type === 2
        ? "order.signPayComfirm"
        : "order.signContract";
      }
      return this.signInfo.type === 2
          ? "order.overseaSignPayComfirm"
          : "order.overseaSignContract";

      
    }
  },
  methods: {
    toSign() {
      window.open(this.signInfo.url);
    }
  }
};
</script>
